import './styles/privacy-page.scss'
import { setup } from './privacy'

const klaroContainer = document.getElementById('klaro-container')

setup(config => {
  config.styling = config.styling || {}
  config.styling.theme = [
    'light',
    'wide'
  ]
}, klaroContainer)
